import { type Notification } from '@linktivity/ars-neo';

export function getNotificationPreview(notification?: Notification): string {
  const description = notification?.content?.description;
  if (!description) return '';
  const newlineIndex = description.indexOf('\n');
  return description.slice(0, newlineIndex >= 0 ? newlineIndex : undefined);
}

export function getNotificationFullContent(
  notification?: Notification
): string {
  return notification?.content?.description ?? '';
}
